import axios from "axios";
import axiosRetry from "axios-retry";
import { envConfig } from "./env-config";

export const axiosInstance = axios.create({
    baseURL: envConfig().httpBaseUrl,
});

let isAlreadyRefreshing = false; // This helps avoid simultaneous request to refresh_token endpoint that leads to bug

// axiosRetry is used to get a refresh token
axiosRetry(axiosInstance, {
    retryDelay: (retryCount) => {
        return retryCount * 1000;
    },
    retries: 2,
    onRetry: async (retryCount, error) => {
        // onRetry is called when a status code 401 is returned from a expired access token
        if (error.response.status === 401 && error.response.data.status === 2) {
            if (isAlreadyRefreshing === false) {
                isAlreadyRefreshing = true
                let refreshResponse;
                try {
                    refreshResponse = await axiosInstance({
                        method: "post",
                        url: "/refresh-token",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        data: {},
                    });
                } catch (error) {
                    localStorage.removeItem("accessToken");
                    console.error(error);
                    location.reload()
                    return Promise.reject(error);
                }

                if (
                    refreshResponse?.data?.data &&
                    refreshResponse?.data?.status === 0
                ) {
                    const accessToken = refreshResponse.data.data;
                    localStorage.setItem("accessToken", accessToken);
                }
                isAlreadyRefreshing = false
            }
            return true;
        }
    },
    retryCondition: (error) => {
        // retry if 401 status code is received
        return (
            error.response.status === 401 && error.response.data.status === 2
        );
    },
});

// allows to modify the request before being sent to server
axiosInstance.interceptors.request.use(
    (request) => {
        let accessToken = localStorage.getItem("accessToken")
            ? localStorage.getItem("accessToken")
            : "";
        request.withCredentials = true; //required for cookie with refresh token to be sent to server
        if (accessToken) {
            request.headers = {
                ...request.headers,
                Authorization: `Bearer ${accessToken}`,
            };
        }
        return request;
    },
    (error) => {
        return Promise.reject(error);
    },
);

// allows to modify the response from the server
axiosInstance.interceptors.response.use(
    (response) => {
        if (response.data.status === 1) {
            throw Error("Server returned error");
        }
        return response;
    },
    (error) => {
        return Promise.reject(error);
    },
);
